import { Component, Input } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-generic-loader',
  templateUrl: './generic-loader.component.html',
  styleUrls: ['./generic-loader.component.css']
})
export class GenericLoaderComponent {
  @Input() isLoader : boolean = false; 
  constructor(private _loaderService: LoaderService) { }
  showLoader: boolean = false;

  ngOnInit() {
    this._loaderService.isLoading$.subscribe((value) => {
      this.showLoader = value;
    });
  }
}
